/**
 * AdminProductEditorPage — thin wrapper mounting the shared `ProductEditor`
 * with the admin adapter (Task F3). Mirrors the seller wrapper's shape
 * (`seller-dashboard/ProductEditorPage.tsx`, Task F2) — reads the route
 * param, resolves the admin port, renders.
 */
import type { ReactElement } from "react";
import { useParams } from "react-router-dom";

import { ProductEditor } from "@/features/product-editor/ProductEditor";
import { useAdminEditorPort } from "@/features/admin/products/editorPort";

export function ProductEditorPage(): ReactElement {
  const { id } = useParams<{ id: string }>();
  const port = useAdminEditorPort();
  return <ProductEditor port={port} routeId={id ?? null} />;
}

export default ProductEditorPage;
